@use '../../../../app/styles/common/colors';
@use '../../../../app/styles/common/mixins';

.card {
  padding: var(--spasing20);
  border-radius: var(--spasing16);
  border: 1px solid var(--border-secondary);
  background: var(--surface-01);

  @include mixins.tablet {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  @include mixins.laptop {
    flex-direction: column;
  }
}

.cardContent {
  display: flex;
  margin-bottom: 16px;

  @include mixins.tablet {
    margin-bottom: 0;
  }

  @include mixins.laptop {
    margin-bottom: 16px;
  }

  @include mixins.desktop {
    margin-bottom: 32px;
  }
}

.description {
  @include mixins.tablet {
    flex: 1 0 377px;
  }

  @include mixins.laptop {
    flex: 1 1 auto;
  }
}

.cardLink {
  @include mixins.tablet {
    max-width: 200px;
    margin-left: 32px;
  }

  @include mixins.laptop {
    max-width: none;
    margin-left: 0;
  }
}

.title {
  font-weight: 600;
  margin-bottom: 6px;
}
